// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2kr_V","containerItemsCenter":"Skeleton_containerItemsCenter__FdHc3"};